class HeroMediaBlock extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.hero-media__list');
    this.items = this.querySelectorAll('.hero-media__item');

    if (!this.list || !this.items.length) return;

    this.initLoadAnimation();
  }

  /* ── Load animation ─────────────────────────────── */
  initLoadAnimation() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Small delay so the page has settled
            setTimeout(() => this.list.classList.add('is-visible'), 120);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(this);
  }
}

customElements.define('hero-media-block', HeroMediaBlock);
